export default __webpack_public_path__ + "static/media/Valerio Aprea.2f9a7693.jpg";